<style>
.horizontal-scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.horizontal-scrolling-wrapper .card {
  flex: 0 0 auto;
  min-width:100%
}
</style>
<template>

  <div>

    <v-card>
      <product-tree-picker v-model="selected" />
      <pre v-if="selected && selected.length > 0"
        v-text="selected.join(',')" class="caption grey lighten-4 pa-3" />
    </v-card>

    <v-card width="600" >
      <v-card-title class='subtitle-1 overline' >
        Upgrade your account
      </v-card-title>
      <v-card-text>
        <v-layout >
          <v-flex xs6 >
            <v-card class="grey lighten-5 my-3" >
              <v-card-title class='title blue-grey darken-4 white--text' >
                STARTER
                <v-spacer />
                <v-chip color="info" class="white--text" >R300</v-chip>
              </v-card-title>
              <v-divider/>
              <v-card-text class="subheading" >
                <ul>
                  <li>Best effort support</li>
                </ul>
                <ul>
                  <li><s>SMS Notifications</s></li>
                </ul>
              </v-card-text>
              <v-card-actions >
                <v-btn color="primary" block >Select Starter</v-btn>
              </v-card-actions>
              <v-card-text >
                <small>* Not eligible for promotions, discounts and special offers</small>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs6 >
            <v-card class="elevation-20 pb-3" height="100%" >
              <v-card-title class='title black white--text' >
                PRO
                <v-spacer />
                <v-chip color="success" class="white--text" >R500</v-chip>
              </v-card-title>
              <v-divider class="mb-3" />
              <v-card-text class="subheading" >
                <div >
                  <div><v-icon small >check</v-icon> Priority support</div>
                  <div><v-icon small >check</v-icon> SMS notifications</div>
                </div>
              </v-card-text>
              <v-card-actions >
                <v-btn color="primary" block >Select Pro</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <div class="my-3 blue-grey--text" >
          <div><v-icon small >check</v-icon> Cancel anytime</div>
          <div><v-icon small >check</v-icon> Change your package whenever you like</div>
        </div>
      </v-card-text>
    </v-card>


    <v-text-field v-model='appointmentId' label='Appointment ID' />
    <v-btn @click='getAppointment(appointmentId)' :loading='requests.appt.loading' >fetch</v-btn>
    <!-- A: {{appointment}} -->
    <v-system-bar dark class='overline' >
      Your appointment
    </v-system-bar>
    <small-appointment-card v-if="appointmentDetail" v-model='appointmentDetail' fetch />
    <!-- <appointment-action
      title='Choose appointments'
      component-name='Payment'
      :component-attrs="{}" /> -->
    <!-- <space-and-location-picker /> -->
    <v-card>
      <v-btn @click='$store.dispatch("fetchAppointments", [181139, 169790, 181766])' >
        Fetch mutation</v-btn>
      <v-btn @click='getAppointmentsInRange' >Fetch appts</v-btn>
      Permission: {{ permissionResult }} |
      <v-text-field v-model='actionName' label='action name' />
      <v-btn @click='permissionResult = hasPermission("foo", 887)' >Check</v-btn>
    <v-btn @click='getClientInfo' >Info</v-btn>
    <pre>{{clientInfo}}</pre>
    </v-card>

    <!-- <invite-member class='ma-3' /> -->



    <!-- <send-template
      :clients='clients'
      templateContext='Appointment' >
    </send-template> -->

    <!-- <zoom-integration >
    </zoom-integration > -->


    <!-- <v-card>
    <phone-number-input v-model='phone' >
    </phone-number-input>
    </v-card> -->

    <!-- <appointment-product :appointment-id='42072' >
    </appointment-product> -->

    <!-- <tag
      :appointment-ids=[42072,42069]
      :original-tags='["foo", "bar", "baz"]' >
    </tag> -->
    <!-- <referral-picker ></referral-picker> -->
    <!-- <appointment-product :appointment-id='33808' >
    </appointment-product > -->
    <!-- <bulk-add></bulk-add> -->
    <!-- <appointment-payment :appointment='33808' >
    </appointment-payment> -->
    <!-- <v-btn @click='doUpgrade' >Upgrade</v-btn> -->
    <!-- <update-wizard ></update-wizard> -->
    <!-- <appointments-after-actions :appointment='appointment' ></appointments-after-actions> -->

    <!-- <v-card class='my-4' >

      <v-card-media height='200px'
        src='https://images.unsplash.com/photo-1533248786003-35fa0e261120?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=5a751615e13e63a62e9c653f231cfa10&auto=format&fit=crop&w=1351&q=80' >
      </v-card-media>
      <center>
        <v-avatar
          style='top:-60px;z-index:7;width:120px;'
          :tile="tile"
          :size="120"
          color="blue-grey darken-4 "
        >
          <img src="https://www.kialo.com/images/6ffa7320-2be4-4687-abb8-c0f39bb389c6_128x128@2x.jpeg" alt="avatar">
        </v-avatar>
      </center>
      <v-card-text class='text-xs-center' style='margin-top:-50px;' >
        <h1 class='heading' >Jaime Lannister</h1>
        <blockquote class='blockquote'>
          The customer will receive a receipt in their email
        </blockquote>
      </v-card-text>
    </v-card> -->

    <!-- <v-card class='my-0'  >

      <v-text-field
        label='choose an invoice'
        v-model='invoiceId' >
      </v-text-field>
      <global-payment :invoice-id='invoiceId' ></global-payment>

      <v-card-media height='200px'
        src='https://images.unsplash.com/photo-1521021153866-f8089b0aa617?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=94418b9bd265c9b30fd8c1f58dd9515c&auto=format&fit=crop&w=500&q=60' >
      </v-card-media>
      <center>
        <v-avatar
          style='top:-60px;z-index:7;width:120px;'
          :size="120"
          color="blue-grey darken-4 "
        >
          <img src="https://media-appointmentguru.s3.amazonaws.com/practitioner/images/412/profile.jpeg" alt="avatar">
        </v-avatar>
      </center>
      <v-card-text class='text-xs-center' style='margin-top:-50px;' >
        <h1 class='heading' >Sarah Smith</h1>
        <blockquote class='blockquote'>
          AppointmentGuru will pick up the payment and automatically:
          create a receipt,
          send it to the customer
          and update the status of the appointment
        </blockquote>
      </v-card-text>
    </v-card>
    <br/><br/><br/><br/><br/><br/><br/> -->
    <!-- <snap-code
      snap-img="https://pos.snapscan.io/qr/EJrKB_SJ.svg?invoice_id=4136&amount=10000&strict=true"
      snap-url="https://pos.snapscan.io/qr/EJrKB_SJ?invoice_id=4136&amount=10000&strict=true" >
    </snap-code> -->

    <!-- <client-card :client-id='client.id' ></client-card> -->
    <!-- <full-create-mobile @client='setClient' ></full-create-mobile> -->
    <!-- <send-templated></send-templated> -->
    <!-- <appointment-pay
      :appointment='appointment' ></appointment-pay> -->
    <!-- <create-invoice style='min-height:800px;' :appointments='appointments' ></create-invoice> -->
    <become></become>
    <!-- <date-range-picker ></date-range-picker> -->
    <!-- <create ></create> -->
    <!-- {{medicalaid}}
    <medical-aid-picker v-model='medicalaid' ></medical-aid-picker> -->
    <!-- Code: {{code}} -->
    <!-- <icd-picker v-model='code' ></icd-picker> -->
    <!-- Process: {{process}}
    <process-code-picker v-model='process' ></process-code-picker> -->
    <!-- <invoice-details :appointment='appointment' ></invoice-details> -->
    <!-- <code-picker :appointment='{id: 11568}' ></code-picker>
    <v-btn @click='slackit' >Slack it</v-btn>

    <pre>Template:{{testAppointment}}</pre>
    <communication-table ></communication-table> -->

    <!-- <invoice-codes :appointment-id='8519' ></invoice-codes> -->
    <!-- <div class='horizontal-scrolling-wrapper mt-3' >
    <v-card v-for='x in [1,2,3,4,5]' :key='x' xs12 sm6 md4 class='mr-3' >
      <v-card-text>
        Some cool appointment <br/>
        Today at 6pm
      </v-card-text>
      <v-card-actions class='white'>
        <v-btn icon slot='activator' >
          <v-icon>check</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn @click.native='openGlobalDialog(true, 'InvoiceCodes', {appointment:appointment})' icon >
          <v-icon>code</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>send</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>open_in_new</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    </div> -->

  </div>
</template>

<script>
import {LIST_APPOINTMENTS_IN_RANGE_REQ} from '@/store/constants'
import InviteMember from '@/components/actions/InviteMember/index.vue'
import ProductTreePicker from '@/components/pickers/ProductTreePicker.vue'
// import MedicalAidPicker from '@/components/pickers/MedicalAidPicker'
// import ConfirmInvoice from '@/components/invoice/manage/create/confirm'
// import AppointmentPicker from '@/components/pickers/AppointmentPicker/index.vue'
// import AppointmentAction from '@/components/actions/AppointmentAction.vue'
// import InvoiceDetails from '@/components/appointment/edit/InvoiceDetails'
// // import CodePicker from '@/components/pickers/CodePicker'
// import CommunicationTable from '@/components/communications/CommunicationTable'
// import IcdPicker from '@/components/pickers/IcdPicker'
// import ProcessCodePicker from '@/components/pickers/ProcessCodePicker'
// import Create from '@/components/client/Create'
// import DateRangePicker from '@/components/pickers/DateRangePicker'
// import CreateInvoice from '@/components/invoice/manage/FullCreate'
// import InvoiceSettings from '@/components/invoice/manage/Settings'
// import AppointmentPay from '@/components/appointment/Pay'
// import QuickCreate from '@/components/invoice/manage/QuickCreate'
// import UpdateWizard from '@/components/ui/UpdateWizard'
// import SendTemplated from '@/components/communications/SendTemplated'
// import FullCreateMobile from '@/components/invoice/manage/FullCreateMobile'
// import ClientCard from '@/components/client/ClientCard'
// import SnapCode from '@/components/ui/SnapCode'
// import AppointmentsAfterActions from '@/components/appointment/actions/After'
// import AppointmentPayment from '@/components/appointment/Pay'
// import GlobalPayment from '@/components/appointment/payment'
import SetClient from '@/components/appointment/SetClient'
import AsyncActionList from '@/components/lists/AsyncActionList'
import PhoneNumberInput from '@/components/PhoneNumberInput'
import BulkAdd from '@/components/client/BulkAdd'
import ZoomIntegration from '@/components/forms/Zoom'
import SmallAppointmentCard from '@/components/cards/SmallAppointmentCard.vue'
// import AppointmentProduct from '@/components/appointment/AppointmentProduct'
import SendTemplate from '@/components/unibox/SendTemplate'
// import ClientCodes from '@/components/client/ClientCodes'
import Become from '@/components/auth/Become'
// import ReferralPicker from '@/components/pickers/ReferralPicker'
// import Tag from '@/components/appointment/Tag'
import axios from 'axios'
import CloneAppointment from '@/components/appointment/actions/CloneAppointment.vue'
import ProductSheet from '@/components/pickers/ProductSheet'
import SpaceAndLocationPicker from '@/components/pickers/SpaceAndLocationPicker'
import AppointmentPriceDetails from '@/components/appointment/edit/AppointmentPriceDetails.vue'

export default {
  name: 'TestPage',
  components: {
    Become,
    BulkAdd,
    InviteMember,
    SpaceAndLocationPicker,
    PhoneNumberInput,
    AsyncActionList,
    SendTemplate,
    ZoomIntegration,
    SetClient,
    AppointmentPriceDetails,
    SmallAppointmentCard,
    ProductTreePicker,
    // AppointmentAction,
    // AppointmentPicker,
    // ConfirmInvoice,
    CloneAppointment,
    ProductSheet
  },
  props: {
    invoiceId: { type: Number, default: 0 }
  },
  data () {
    return {
      code: null,
      process: null,
      permissionResult: false,
      appointmentId: null,
      actionName: 'foo',
      appts: [],
      selected: [],
      medicalaid: null,
      viz: true,
      client: {
        id: 1
      },
      practitioner: {
        id: 2138
      },
      requests: {
        invoice: 'invoice-detail-req-id',
        rel: {
          resource: 'ag.spaces.relationships',
          resourceId: '38521'
        },
        appt: {
          resource: 'ag.appointments'
        }
      },
      clientInfo: {
        ip: null,
        data: {}
      },
      phone: '‭+573209276694‬',
      touch: 1
    }
  },
  mounted () {
    this.getAppointmentsInRange()
    if (this.practitioners) {
      this.practitioner = Object.values(this.practitioners)[1]
    }
  },
  computed: {
    appointments () {
      return this.$store.getters.appointments
    },
    appointment () {
      if (this.appointments && this.appointments.length > 0) {
        let index = Math.round(Math.random() * this.appointments.length)
        return this.appointments[index]
      }
    },
    appointmentDetail () {
      return this.getObjectPath(this.requests, 'appt.result', null)
    },
    practitioners () {
      return this.$store.getters.lookups.practitioners
    },
    clients () {
      return this.$store.getters.clients.slice(0, 3)
    },
    appointmentsReq () {
      let req = this.$store.getters.getRequestById(LIST_APPOINTMENTS_IN_RANGE_REQ, true)
      return req
    },
    invoice () {
      let req = this.$store.getters.getRequestById(this.requests.invoice, false)
      if (req.result) {
        return req.result.data
      }
      return {}
    }
  },
  watch: {
    invoiceId () {
      this.getInvoice()
    }
  },
  methods: {
    getRelationship () {
      this.$request('get', this.requests.rel)
    },
    getAppointment (id) {
      this.requests.appt.resourceId = id
      this.$request('get', this.requests.appt)
    },
    getClientInfo () {
      let vm = this
      axios.get('https://api.ipify.org?format=json')
        .then((res) => {
          let ip = res.data.ip
          vm.clientInfo.ip = res.data.ip
          axios.get('https://api.clearip.io/ip/' + ip + '/json?apikey=yc757b5c92afdf1529102430eda36316')
            .then((res) => {
              vm.clientInfo.data = res.data
            })
        })
    },
    setClient (client) {
      this.client = client
    },
    slackit () {
      this.$communicationguru.resource('slack').list()
    },
    getInvoice () {
      if (this.invoiceId && this.invoiceId > 0) {
        this.$invoiceguru.resource('invoices')
          .id(this.requests.invoice)
          .get(this.invoiceId)
      }
    },
    doUpgrade () {
      this.$invoiceguru.resource('upgrade').id('upgrade').create()
    }
  }
}
// {'price':0,'description':null,'icd10':'M21.97','process':'91931','procedure':null,'nappi':null,'appointment':10462}
</script>

<style>

</style>



// WEBPACK FOOTER //
// TestPage.vue?795c5b46